module.exports = __webpack_public_path__ + "static/img/pic4.3e399998.png";